/**
 * Site announcement (solutionsoutsourced/site-announcement).
 *
 * The announcement is always rendered (so the page stays cacheable) and only
 * revealed here once we know the visitor hasn't dismissed it. Popup
 * announcements lock page scrolling while they're open.
 */
(function () {
    var COOKIE = 'noticeDismissed';
    var LOCK_CLASS = 'site-announcement-locked';

    function dismissed() {
        return document.cookie.split(';').some(function (part) {
            return part.trim().indexOf(COOKIE + '=') === 0;
        });
    }

    function lockScroll() {
        var root = document.documentElement;
        var scrollbar = window.innerWidth - root.clientWidth;
        root.style.setProperty('--site-announcement-scrollbar-width', scrollbar + 'px');
        root.classList.add(LOCK_CLASS);
    }

    function unlockScroll() {
        var root = document.documentElement;
        root.classList.remove(LOCK_CLASS);
        root.style.removeProperty('--site-announcement-scrollbar-width');
    }

    function init() {
        var announcement = document.querySelector('[data-site-announcement]');

        if (!announcement || dismissed()) {
            return;
        }

        var isPopup = announcement.getAttribute('data-position') === 'popup';
        var previousFocus = document.activeElement;

        function dismiss() {
            document.cookie = COOKIE + '=true; path=/; SameSite=Lax';
            announcement.hidden = true;

            if (isPopup) {
                unlockScroll();
                document.removeEventListener('keydown', onKeydown);

                if (previousFocus && typeof previousFocus.focus === 'function') {
                    previousFocus.focus();
                }
            }
        }

        function onKeydown(event) {
            if (event.key === 'Escape' || event.key === 'Esc') {
                dismiss();
            }
        }

        Array.prototype.forEach.call(
            announcement.querySelectorAll('[data-site-announcement-dismiss]'),
            function (trigger) {
                trigger.addEventListener('click', function (event) {
                    event.preventDefault();
                    dismiss();
                });
            }
        );

        announcement.hidden = false;

        if (isPopup) {
            lockScroll();
            document.addEventListener('keydown', onKeydown);

            var panel = announcement.querySelector('.site-announcement__panel');
            if (panel) {
                panel.focus();
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
